import React from 'react'
import { MatrixUtil, MatrixDomUtil } from 'aria-viewer/utils/matrix'

const getTransform = ({ points: c, width: w, height: h, x, y, z }) => {
    const projection = MatrixUtil.general2DProjection(
        0,
        0,
        c[0].x,
        c[0].y,
        w,
        0,
        c[1].x,
        c[1].y,
        0,
        h,
        c[2].x,
        c[2].y,
        w,
        h,
        c[3].x,
        c[3].y
    )

    return MatrixDomUtil.getMatrixString(projection)
}

const CSSMatrix3DDistortion = ({ className, width, height, children, x, y, z, points, zIndex }) => {
    const transform = getTransform({ width, height, x, y, z, points })

    return (
        <div
            className={className}
            style={{
                width,
                height,
                transform: transform,
                transformOrigin: '0px 0px',
                zIndex,
            }}
        >
            {children}
        </div>
    )
}

CSSMatrix3DDistortion.defaultProps = {
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    z: 0,
    points: [],
    zIndex: 0,
}

export default CSSMatrix3DDistortion
